"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductAssertionBatchMeasuresInput = exports.getProductAssertionBatchLabelsInput = exports.getProductAssertionBatchCategoriesInput = exports.BulkAssertionOperationTypes = void 0;
const graphql_1 = require("../../../../__generated__/graphql");
var BulkAssertionOperationTypes;
(function (BulkAssertionOperationTypes) {
    BulkAssertionOperationTypes["Replace"] = "replace";
    BulkAssertionOperationTypes["Merge"] = "merge";
    BulkAssertionOperationTypes["Delete"] = "delete";
    BulkAssertionOperationTypes["DeleteAll"] = "deleteAll";
})(BulkAssertionOperationTypes || (exports.BulkAssertionOperationTypes = BulkAssertionOperationTypes = {}));
const getAssertionTypes = (operationType) => {
    switch (operationType) {
        case BulkAssertionOperationTypes.Replace:
            return [graphql_1.ProductAttributeAssertionType.Exclusive, graphql_1.ProductAttributeAssertionType.Positive];
        case BulkAssertionOperationTypes.Merge:
            return [graphql_1.ProductAttributeAssertionType.Positive, graphql_1.ProductAttributeAssertionType.Positive];
        case BulkAssertionOperationTypes.Delete:
            return [graphql_1.ProductAttributeAssertionType.Negative, graphql_1.ProductAttributeAssertionType.Negative];
        case BulkAssertionOperationTypes.DeleteAll:
            return [graphql_1.ProductAttributeAssertionType.Exclusive];
    }
};
const getProductAssertionBatchCategoriesInput = (category) => [{
        category,
        type: graphql_1.ProductAttributeAssertionType.Exclusive,
    }];
exports.getProductAssertionBatchCategoriesInput = getProductAssertionBatchCategoriesInput;
const getProductAssertionBatchLabelsInput = (operationType, attributeId, values = []) => {
    const [firstElementAssertionType, restElementsAssertionType] = getAssertionTypes(operationType);
    if (!restElementsAssertionType) {
        return [{
                label: attributeId,
                type: firstElementAssertionType,
                value: null,
            }];
    }
    const [firstElement, ...restElements] = values;
    const firstLabel = {
        label: attributeId,
        type: firstElementAssertionType,
        value: firstElement,
    };
    const labels = restElements.map((value) => ({
        label: attributeId,
        type: restElementsAssertionType,
        value,
    }));
    return [firstLabel, ...labels];
};
exports.getProductAssertionBatchLabelsInput = getProductAssertionBatchLabelsInput;
const getProductAssertionBatchMeasuresInput = (operationType, attributeId, values = []) => {
    const [firstElementAssertionType, restElementsAssertionType] = getAssertionTypes(operationType);
    if (!restElementsAssertionType) {
        return [{
                dimension: attributeId,
                type: firstElementAssertionType,
                value: null,
            }];
    }
    const [firstElement, ...restElements] = values;
    const firstMeasure = {
        dimension: attributeId,
        type: firstElementAssertionType,
        unit: firstElement.unit,
        value: firstElement.value,
    };
    const measures = restElements.map(({ unit, value }) => ({
        dimension: attributeId,
        type: restElementsAssertionType,
        unit,
        value,
    }));
    return [firstMeasure, ...measures];
};
exports.getProductAssertionBatchMeasuresInput = getProductAssertionBatchMeasuresInput;
